import type { HeaderScheme } from '@/types'

/**
 * Reads the `data-header` attribute of the section under a viewport point,
 * ignoring the element doing the asking (a fixed header or ruler).
 */
export const detectScheme = (x: number, y: number, ignore: Element | null): HeaderScheme => {
    const stack = document.elementsFromPoint(Math.max(0, x), Math.max(0, y))

    for (const el of stack) {
        if (ignore && ignore.contains(el)) continue

        const section = el.closest('[data-header]')

        if (section) return section.getAttribute('data-header') === 'light' ? 'light' : 'dark'
    }

    return 'light'
}
